import { Profile } from '@foxcorp/foxkit-profile-js';
import Cookies from 'universal-cookie';
import { getRandomUUID } from './GetRandomUUID';
import { EXTERNAL_DEVICE_ID_PARAM_NAME } from './Constants';

const setXidCookie = (cookieName, value) => {
  const cookies = new Cookies();
  const isNewsDomain = typeof window !== 'undefined' && window.location.hostname.endsWith('.foxnews.com');

  return cookies.set(cookieName, value, {
    ...(isNewsDomain ? { domain: window.location.hostname } : {}),
    path: '/',
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 400),
    sameSite: 'lax',
    secure: true,
  });
};

// Migrate old cookie formats to new way of handling xid
// TODO: Remove this function after cookies have been migrated
const temporaryMigrateCookie = (cookieName) => {
  if (typeof window === 'undefined') {
    return;
  }

  const cookies = new Cookies();

  const newCookieValue = cookies.get(cookieName);

  const existingXid = localStorage.getItem('xid') ?? localStorage.getItem('FOXAUTHXID');

  if (existingXid) {
    if (!newCookieValue) {
      setXidCookie(cookieName, existingXid);
    }

    localStorage.removeItem('xid');
    localStorage.removeItem('FOXAUTHXID');
  }
};

// Copied from foxcorp-product/fox-webapp/packages/shared/utils/profileSDK/index.ts
export class ExtendedProfileSDK extends Profile {
  isXidRequesting;
  deviceIdCookieName;

  constructor(profileSDKConfig, deviceIdCookieName) {
    super(profileSDKConfig);

    this.deviceIdCookieName = deviceIdCookieName;
    this.isXidRequesting = false;
  }

  getUserXid() {
    temporaryMigrateCookie(this.deviceIdCookieName);

    const cookies = new Cookies();

    const getXidValue = () => {
      const searchParams = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');

      const externalXidParam = searchParams.get(EXTERNAL_DEVICE_ID_PARAM_NAME);

      // Always override, regardless of if it already exists
      if (externalXidParam) {
        return externalXidParam;
      }

      const xidCookie = cookies.get(this.deviceIdCookieName);

      if (xidCookie) {
        return xidCookie;
      }

      return getRandomUUID();
    };

    const xidValue = getXidValue();

    if (xidValue) {
      setXidCookie(this.deviceIdCookieName, xidValue);
    }

    return xidValue;
  }
}
